// The official Byrdsense tagline (Pete, 2026-10-10). One source for the site,
// the portal login and tests; index.html carries its own copy (static HTML).
export const TAGLINE = 'Industrial equipment monitoring with a phone call.';

// Where the tagline wraps, keep "phone call." together (no one-word last line).
export const noOrphan = (s) => s.replace(/ (\S+)$/, '\u00a0$1');
